import React from 'react';
import { find } from 'lodash';

import { ExamSectionIcon } from '@magoosh/lib/icons';
import { titleize } from 'utilities/formatting';

import { SubjectData } from './types';

interface Props {
  data: SubjectData[];
  section: string;
}

const SubjectHeader: React.FC<Props> = (props) => {
  const overallDataPoint = find(props.data, (datum) => datum.name === 'Overall');

  return (
    <div className="align-items-center d-flex gap-s">
      <ExamSectionIcon subject={props.section} />
      <h3 className="u-margin-A-n">{titleize(props.section).replace(' And ', ' & ')}</h3>

      {
        overallDataPoint && (
          <div style={{ fontSize: 18}}>
            ({overallDataPoint.answers.total ? `${overallDataPoint.answers.percentCorrect}% correct` : 'No activity'})
          </div>
      )
      }
    </div>
  );
};

export default SubjectHeader;
